<template lang="html">
  <div>
    <div class="section-container">
      <div class="text-to-left">
        <div>
        <h2>The original and best</h2>
        <p>We invented contextual recruitment in 2015. We’ve made hundreds of freedom of information requests. We’ve
          devoted thousands of hours of researcher, analyst, and developer time. And we’ve built the only comprehensive
          database of every key stage 4 and 5 school in England, Scotland, Wales and Northern Ireland.
        </p>
        </div>
      </div>
      <div class="image-right" :id="animations[0]">
      </div>
    </div>

    <div class="section-container reverse-for-small">
      <div class="image-left" :id="animations[3]">
        &nbsp;
      </div>
      <div class="text-to-right">
        <div>
          <h2>Truly secure</h2>
          <p>Use sensitive personal data safely in decision-making. Our CRS has platinum-level information security with ISO27001 accreditation. No other contextual recruitment provider has this.</p>
        </div>
      </div>
    </div>

    <div class="section-container">
      <div class="text-to-left">
        <div>
          <h2>Market-leading industry benchmarking</h2>
          <p>Compare your social mobility statistics to industry averages and see how you’re faring against your
            competitors. With 2 million lines of data and 125+ clients, we can draw truly meaningful comparisons.
            No one else can.
          </p>
        </div>
      </div>
      <div class="image-right" :id="animations[2]">
      </div>
    </div>

    <div class="section-container reverse-for-small">
      <div class="image-left" :id="animations[1]">
      </div>
      <div class="text-to-right">
      <div>
        <h2>Identify resilient outperformers</h2>
        <p>Find the candidates who outperformed substantially at school – the same candidates who independent studies
          show go on to outperform in the workplace.</p>
      </div>
      </div>
    </div>

    <div class="section-container">
      <div class="text-to-left">
        <div>
          <h2>14 ATS integrations</h2>
          <p>The CRS can integrate with: AllHires, Amberjack, Avature, Candid ATS, Cappfinity, CVMail, eArcu, Engage
            ATS, gti, Kenexa BrassRing, Tribepad, Salesforce, SuccessFactors and Taleo. The CRS is also available as a standalone product.
          </p>
        </div>
      </div>
      <div class="image-right image-5">
        &nbsp;
      </div>
    </div>
  </div>
</template>

<script>

import Bodymovin from 'lottie-web';

export default {
  name: 'HomeProductsCrsMainSection',
  props: {
  },
  components: {
  },
  data() {
    return {
      animations: [
        'social',
        'identify',
        'benchmark',
        'security',
      ],
    };
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
    this.animations.forEach((animation) => {
      Bodymovin.loadAnimation({
        container: document.getElementById(animation),
        path: `${window.location.origin}/static/animations/${animation}.json`,
        renderer: 'svg',
        loop: true,
        autoplay: true,
      });
    });
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

.container {
}

.section-container {
  display: flex;
  min-height: 450px;
}

.text-to-left, .text-to-right {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: center;
  width: 58%;
  padding: 0 7% 0 8%;
}

.text-to-left h2, .text-to-right h2 {
  font-family: Europa !important;
  font-size: 56px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
}

.text-to-left p, .text-to-right p {
  font-family: Europa !important;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  margin: 10px 0 50px 0;
}

.text-to-left p, .text-to-left h2 {
  color: $main-text;
}

.text-to-right p, .text-to-right h2 {
  color: $white-text;
}

.text-to-left {
  background-color: $light-grey-background;
}

.text-to-right {
  background-color: $dark-grey-background;
}

.image-left, .image-right {
  background-position: center center;
  background-size: cover;
  width: 42%;
  height: 450px;
}

@media only screen and (max-width: 800px) {
  // This is a bit of a hack on the security image because it was displaying too low in the div.
  // Bit tricky to fix as the lottie is automatically rendered.
  #security {
    margin-bottom: 20px;
    margin-top: -20px;
    max-height: 240px;
  }

  .section-container {
    flex-direction: column;
    min-height: auto;
  }

  .reverse-for-small {
    flex-direction: column-reverse !important;
  }

  .text-to-left, .text-to-right {
    width: 100%;
    padding: 0 20px;
  }

  .text-to-left h2, .text-to-right h2 {
    font-size: 26px;
    font-weight: bold;
    line-height: 1.39;
    letter-spacing: 1px;
    margin: 32px 0 0 0;
  }

  .text-to-left p, .text-to-right p {
    font-size: 18px;
    line-height: 1.43;
    letter-spacing: normal;
    margin: 20px 0 40px 0;
  }

  .image-left, .image-right {
    width: 100%;
    height: 240px;
  }
}

@media only screen and (min-width: 800px) {
  .text-to-left p:last-of-type, .text-to-right p:last-of-type {
    margin-bottom: 0;
  }
}

.image-5 {
  background-image: url("../../../../assets/img/crsImages/image5.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
}

</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProductsCrs/components/homeProductsCrsMainSection.vue